import { render, staticRenderFns } from "./change_centrum.vue?vue&type=template&id=a4cf1410&"
import script from "./change_centrum.vue?vue&type=script&lang=js&"
export * from "./change_centrum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4cf1410')) {
      api.createRecord('a4cf1410', component.options)
    } else {
      api.reload('a4cf1410', component.options)
    }
    module.hot.accept("./change_centrum.vue?vue&type=template&id=a4cf1410&", function () {
      api.rerender('a4cf1410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/change_centrum.vue"
export default component.exports